/**
 * Extract login Custom texts and colors out of array
 * @param {Array} array - long or short version string.
 * @param {boolean} isNcOnPremDeployment - is the deployment NC on prem or not
 * @return {Object} - customLogin key and value
 */
export const getLoginCustomObj = (array, isNcOnPremDeployment = false) => {
    const customLoginObj = {};
    if (isNcOnPremDeployment) {
        customLoginObj.product_title = 'nutanix central';
    }
    if (array && array.length) {
        for (const obj of array) {
            const { key, value } = obj;
            if (!customLoginObj[key]) {
                customLoginObj[key] = value;
            }
        }
    }
    return customLoginObj;
};
